import { TwoTimeCashIncentiveTierData } from '@sections/TwoTimeCashIncentiveSection'

// Two Time Cash Incentive
export function twoTimeCaseIncentiveFirstYearData(): TwoTimeCashIncentiveTierData[] {
  const firstYearData: TwoTimeCashIncentiveTierData[] = [
    { name: 'firstYearGold', tier: 'gold', label: 'TWO_TIME_CASH_1_GOLD' },
    { name: 'firstYearNewPlatinum', tier: 'platinum', label: 'TWO_TIME_CASH_1_NEW_PLATINUM' },
    { name: 'firstYearFPlatinum', tier: 'platinumF', label: 'TWO_TIME_CASH_1_F_PLATINUM' },
    { name: 'firstYearSapphire', tier: 'sapphire', label: 'TWO_TIME_CASH_1_SAPPHIRE' },
    { name: 'firstYearFSapphire', tier: 'sapphireF', label: 'TWO_TIME_CASH_1_F_SAPPHIRE' },
    { name: 'firstYearEmerald', tier: 'emerald', label: 'TWO_TIME_CASH_1_EMERALD' },
    { name: 'firstYearFEmerald', tier: 'emeraldF', label: 'TWO_TIME_CASH_1_F_EMERALD' },
    { name: 'firstYearDiamond', tier: 'diamond', label: 'TWO_TIME_CASH_1_DIAMOND' },
    { name: 'firstYearFDiamond', tier: 'diamondF', label: 'TWO_TIME_CASH_1_F_DIAMOND' }
  ]
  return firstYearData
}

export function twoTimeCaseIncentiveSecondYearData(): TwoTimeCashIncentiveTierData[] {
  const secondYearData: TwoTimeCashIncentiveTierData[] = [
    { name: 'secondYearGold', tier: 'gold', label: 'TWO_TIME_CASH_2_GOLD' },
    { name: 'secondYearPlatinum', tier: 'platinum', label: 'TWO_TIME_CASH_2_PLATINUM' },
    { name: 'secondYearFPlatinum', tier: 'platinumF', label: 'TWO_TIME_CASH_2_F_PLATINUM' },
    { name: 'secondYearSapphire', tier: 'sapphire', label: 'TWO_TIME_CASH_2_SAPPHIRE' },
    { name: 'secondYearFSapphire', tier: 'sapphireF', label: 'TWO_TIME_CASH_2_F_SAPPHIRE' },
    { name: 'secondYearEmerald', tier: 'emerald', label: 'TWO_TIME_CASH_2_EMERALD' },
    { name: 'secondYearFEmerald', tier: 'emeraldF', label: 'TWO_TIME_CASH_2_F_EMERALD' },
    { name: 'secondYearDiamond', tier: 'diamond', label: 'TWO_TIME_CASH_2_DIAMOND' },
    { name: 'secondYearFDiamond', tier: 'diamondF', label: 'TWO_TIME_CASH_2_F_DIAMOND' }
  ]

  return secondYearData
}
